import Service from '@ember/service';
// this is a blank service that gets exported by default
// we do this because the api service needs a config service - exporting a blank one will stop it from erroring
// if you need to override it, create a service in your app/servcies/config.js
export default class ConfigService extends Service {
  app?: {
    baseServiceHost?: string;
    baseIDPHost?: string;
    defaultRoute?: string;
    apiTarget?: string;
  };
  environment?: string;
}
